import { Outlet } from 'react-router-dom'
import { HelpBot } from '../../HelpBot'
import { HelpBotProvider } from '../../../../context/HelpBotContext'

const HelpBotLayout = () => {
    return (
        <HelpBotProvider>
            <Outlet />
            <HelpBot />
        </HelpBotProvider>
    )
}

export default HelpBotLayout
